import SearchFilterMenu from './SearchFilterMenu';
export default SearchFilterMenu;